enum Browsers {
  Firefox = 'Mozilla Firefox',
  Chrome = 'Google Chrome',
  Safari = 'Safari',
  Edge = 'Microsoft Edge',
  Opera = 'Opera',
  Yandex = 'Yandex Browser',
  Unknown = 'Unknown',
}

export const getBrowserInfo = (): string => {
  const { userAgent } = navigator;

  const getVersion = (pattern: RegExp): string => {
    const match = userAgent.match(pattern);
    return match ? match[1] : 'Unknown';
  };

  if (userAgent.includes('Firefox')) {
    return `${Browsers.Firefox} ${getVersion(/Firefox\/(\S+)/)}`;
  }

  if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
    return `${Browsers.Opera} ${getVersion(/OPR\/(\S+)/)}`;
  }

  if (userAgent.includes('Edg')) {
    return `${Browsers.Edge} ${getVersion(/Edg\/(\S+)/)}`;
  }

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    // Из-за политики безопасности минорная версия теряется при использовании userAgent. Поэтому так
    const majorVersion = getVersion(/Chrome\/(\d+)/);
    return `${Browsers.Chrome} ${majorVersion}`;
  }

  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return `${Browsers.Safari} ${getVersion(/Version\/(\S+)/)}`;
  }

  if (userAgent.includes('YaBrowser')) {
    return `${Browsers.Yandex} ${getVersion(/YaBrowser\/(\S+)/)}`;
  }

  return `${Browsers.Unknown} Unknown`;
};
